import { render, staticRenderFns } from "./PropertyTags.vue?vue&type=template&id=71f6f653&"
import script from "./PropertyTags.vue?vue&type=script&lang=ts&"
export * from "./PropertyTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports